import * as React from 'react'
import styled, { css, keyframes } from 'styled-components'

const Shimmer = keyframes`
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: -200% 0; 
  }
`

const Loading = styled.div`
  width: 100%;
  height: 3rem;
  border-radius: 3rem;
  background-image: repeating-linear-gradient(
    to right,
    rgba(211, 211, 211, 0.5) 0%,
    transparent 33%,
    rgba(211, 211, 211, 0.5) 100%
  );
  background-size: 200% auto;
  background-position: 0 100%;
  display: inline-block;
  position: relative;
  margin-bottom: 1rem;

  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${Shimmer};
  animation-timing-function: linear;

  ${props =>
    props.size === 'small' &&
    css`
      height: 1.5rem;
      border-radius: 1.5rem;
      margin-bottom: 0.75rem;
      transition: width var(--animation-duration) var(--animation-easing);

      ${props.last &&
        css`
          width: 75%;
        `}
    `}
`

function LoadingBase(props) {
  const { lines, size } = props

  return (
    <>
      <Loading size={size} {...props} />
      {lines &&
        Array.from(Array(lines)).map((l, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Loading size="small" key={index} last={index + 1 === lines} />
        ))}
    </>
  )
}

export default LoadingBase
